import projectImg from "../../../assets/images/greenshine/greenshine-report.png";
const OurProjects = () => {
  return (
    <div className=" my-20 md:px-16 px-8 space-y-10 md:space-y-20">
      <h5 className="text-4xl font-bold text-center">Our projects</h5>

      <div className="flex gap-5 flex-col md:flex-row">
        <div className="flex-1 flex items-center justify-center">
          <img
            src={projectImg}
            className="w-[min(500px,100%)]"
            alt="Projext Image"
          />
        </div>
        <div className="space-y-5 flex-1">
          <p className="indent-5">
            အီးဂတ်ပတ်ဝန်းကျင်ဆိုင်ရာ ဝန်ဆောင်မှုမှ ဧရာဝတီတိုင်းဒေသကြီး၊
            ပုသိမ်ခရိုင်၊ ကန်ကြီးထောင့်မြို့နယ်၊ ချောင်းဆောက်ကျေးရွာအုပ်စု၊
            ပုသိမ်-ငပုတောကားလမ်း၊ ပုသိမ်စက်မှုမြို့တော်၊ အမှတ် (၅၃-စီ) တွင်
            အကောင်အထည်ဖော်ဆောင်ရွက်နေသည့် Green Shine Co., Ltd. ၏ ဆန်၊ ပြောင်း၊
            ပဲ အမျိုးမျိုး ကြိတ်ခွဲထုတ်လုပ်ခြင်းနှင့် တင်ပို့ရောင်းချခြင်း
            လုပ်ငန်းအတွက် တာဝန်ယူရေးသားပြုစုခဲ့သော ကနဦး ပတ်ဝန်းကျင်ဆန်းစစ်ခြင်း
            အစီရင်ခံစာကို အများပြည်သူ လေ့လာဖတ်ရှုပြီး အကြံပြုပေးနိုင်ရန် အတွက်
            ဖော်ပြပါ Link မှတဆင့် ဝင်ရောက် ရယူနိုင်ပါသည်။
          </p>
          <a className="block text-blue-600" href="https://bit.ly/43p7lk0">
            https://bit.ly/43p7lk0
          </a>
        </div>
      </div>
    </div>
  );
};

export default OurProjects;
